<div *ngIf="loaded">
  <div class="bff-form-row mb-3">
    <div class="bff-form-group bff-text" [innerHTML]="'param.modal.version.paypal-infos-pro' | translate"></div>
  </div>
  <!-- PayPal button -->
  <div class="bff-button-container bff-button-container--center">
    <button type="button" class="bff-button bff-button--full-mobile" (click)="subscribe()" [disabled]="!paypalButtonId || paypalButtonId.trim() === ''"
            style="background: transparent; border: none; padding: 4px;">
      <img src="https://www.paypalobjects.com/fr_FR/FR/i/btn/btn_subscribeCC_LG.gif"
           alt="PayPal, le réflexe sécurité pour payer en ligne"
           style="height: 44px; vertical-align: middle;">
    </button>
    <div *ngIf="!paypalButtonId || paypalButtonId.trim() === ''" class="bff-alert bff-alert--warning" style="margin-top: 1rem;">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Les boutons PayPal PRO ne sont pas configurés. Veuillez contacter le support.</span>
    </div>
    <div><br/></div>
  </div>
</div>
<div *ngIf="!loaded" class="bff-loading-overlay">
  <img src="/assets/images/loader.gif" alt="loading" class="bff-loading-icon" />
</div>



